export default "__VITE_PUBLIC_ASSET__9ccc6c40__"